/* eslint-disable camelcase */
import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import inboxOutline from "@iconify/icons-eva/inbox-outline";
// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import externalLinkFill from "@iconify/icons-eva/external-link-fill";
// components
import Page from "../../../../components/Page";
import TagsOptions from "../components/CourtesyOptions";
import Scrollbar from "../../../../components/Scrollbar";
import TagsListHead from "../components/CourtesyListHead";
import TagsListToolbar from "../components/CourtesyListToolbar";

import tagService from "../services/CourtesyService";
import CourtesyModal from "../components/CourtesyModal";
import AlertMessage from "../../../../components/alert/alert";
import CourtesyModalClient from "../components/CourtesyModalClient";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "name_Customer", label: "Cliente", alignRight: false },

  { id: "id_Customer", label: "ID do Cliente", alignRight: false },
  { id: "totalCourtesy", label: "Enviadas", alignRight: false },
  { id: "approvedCourtesy", label: "Históricos", alignRight: false },

  { id: "", label: "Ver mais" },
];

// ----------------------------------------------------------------------

export default function Courtesy() {
  const [page, setPage] = useState(0);
  const [data, setData]: any = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [params, setParams]: any = useState({ value: "" });
  const [notFirstQuery, setNotFirstQuery] = useState(false);
  const [showError, setError] = useState(false);
  const [showSuccess, setSuccess] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenClient, setModalOpenClient] = useState(false);
  const [queryStartEnd, setQueryStartEnd] = useState([
    "0",
    rowsPerPage.toString(),
  ]);
  const [type, setType] = useState("send");
  const [clientSelected, setClientSelected] = useState({});
  useEffect(() => {
    tagService
      .getAll(queryStartEnd[0], queryStartEnd[1], params)
      .then((data: any) => setData(data.data))
      .catch((error: any) => console.error(error));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryStartEnd, modalOpen]);

  useEffect(() => {
    const timeOutId = setTimeout(
      () =>
        notFirstQuery
          ? tagService
              .getAll(queryStartEnd[0], queryStartEnd[1], params)
              .then((data: any) => setData(data.data))
              .catch((error: any) => console.error(error))
          : setNotFirstQuery(true),
      500
    );

    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, modalOpen]);

  const handleChangePage = (event: any, newPage: any) => {
    const finalPage = newPage > 0 ? page + 1 : page - 1;
    setQueryStartEnd([
      ((finalPage + 1) * rowsPerPage - rowsPerPage).toString(),
      rowsPerPage.toString(),
    ]);
    setPage(finalPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    const finalRowsPerPage = parseInt(event.target.value);
    setQueryStartEnd([
      ((page + 1) * finalRowsPerPage - finalRowsPerPage).toString(),
      finalRowsPerPage.toString(),
    ]);
    setRowsPerPage(finalRowsPerPage);
    setPage(0);
  };
  useEffect(() => {
    if (showError) setTimeout(() => setError(false), 2000);
    if (showSuccess) setTimeout(() => setSuccess(false), 2000);
  }, [showError, showSuccess]);
  return (
    <Page title="Etiquetas | Optools">
      <CourtesyModal
        open={modalOpen}
        title="Números das Notas"
        confirmButtonText="Gerar"
        setError={() => setError(true)}
        handler={() => setModalOpen(false)}
        setSuccess={() => setSuccess(true)}
      />

      <CourtesyModalClient
        open={modalOpenClient}
        title="Números das Notas"
        confirmButtonText="Gerar"
        setError={() => setError(true)}
        handler={() => setModalOpenClient(false)}
        setSuccess={() => setSuccess(true)}
        data={clientSelected}
        type={type}
      />
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h4" gutterBottom>
            Gerenciamento de Cortesias
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between">
          <TagsListToolbar
            filterName={params.value}
            onFilterName={(event: any) => {
              setPage(0);
              setQueryStartEnd(["0", rowsPerPage.toString()]);
              setParams({ ...params, value: event.target.value });
            }}
          />
          <Button
            sx={{
              height: "48px",
              borderRadius: "40px",
              background: "#004A78",
              marginTop: [0, "36px"],
              marginBottom: [3, 0],
              "&:hover": {
                bgcolor: "#226C9A",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
            color="secondary"
          >
            Adicionar Cortesia
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TagsListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {data.length ? (
                    data.slice(0, rowsPerPage).map((row: any) => {
                      const {
                        id_Customer,
                        name_Customer,
                        totalCourtesy,
                        approvedCourtesy,
                        initials_Customer,
                      } = row;

                      return (
                        <TableRow
                          hover
                          tabIndex={-1}
                          role="checkbox"
                          key={id_Customer}
                        >
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {name_Customer}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {initials_Customer}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <IconButton
                              onClick={() => {
                                setType("send");
                                setModalOpenClient(true);
                                setClientSelected(row);
                              }}
                            >
                              <Box
                                component={Icon}
                                icon={externalLinkFill}
                                sx={{
                                  width: 16,
                                  height: 16,
                                  ml: 1,
                                }}
                              />
                            </IconButton>
                          </TableCell>
                          <TableCell align="left">
                            <IconButton
                              onClick={() => {
                                setType("historic");
                                setModalOpenClient(true);
                                setClientSelected(row);
                              }}
                            >
                              <Box
                                component={Icon}
                                icon={externalLinkFill}
                                sx={{
                                  width: 16,
                                  height: 16,
                                  ml: 1,
                                }}
                              />
                            </IconButton>
                          </TableCell>
                          <TableCell align="left">
                            <IconButton
                              onClick={() => {
                                setType("more");
                                setModalOpenClient(true);
                                setClientSelected(row);
                              }}
                            >
                              <Box
                                component={Icon}
                                icon={externalLinkFill}
                                sx={{
                                  width: 16,
                                  height: 16,
                                  ml: 1,
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                        <Stack
                          width="100%"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Icon
                            icon={inboxOutline}
                            width="56px"
                            color="#909090"
                          />
                          <Typography
                            mt={1}
                            variant="body1"
                            noWrap
                            sx={{ color: "#909090" }}
                          >
                            Nenhum item encontrado...
                          </Typography>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          {/*           <TablePagination
            page={0}
            component="div"
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            rowsPerPageOptions={[20, 40, 60]}
            backIconButtonProps={{ disabled: !page }}
            labelRowsPerPage="Linhas por página:"
            nextIconButtonProps={{
              disabled:
                (page + 1) * rowsPerPage >= data[0]?.totalCustomer ||
                data.length < rowsPerPage,
            }}
            labelDisplayedRows={(rowsInfo) => {
              const totalPages = Math.ceil(
                rowsInfo.count / rowsPerPage
              ).toString();
              return (
                <>
                  {`Página: ${page + 1}${
                    !params.value.length
                      ? `/${totalPages === "0" ? "1" : totalPages}`
                      : ""
                  }`}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {!params.value.length ? `Total: ${rowsInfo.count}` : ""}
                </>
              );
            }}
            onRowsPerPageChange={handleChangeRowsPerPage}
            count={data?.length ? data[0].totalCustomer : 0}
          /> */}
        </Card>
      </Container>
      {showSuccess && (
        <AlertMessage open={true} message="Cortesia Adicionada com sucesso!" />
      )}
      {showError && (
        <AlertMessage open={true} message="Erro ao efetuar atualização" />
      )}
    </Page>
  );
}
